import { BRAINTREE, REVENUE_CAT } from 'constants/plans.constants';
import i18n from 'i18n';
import { isEmpty } from 'lodash';
import moment, { Moment } from 'moment';

const monthlyMetadata = [
  'All 20+ Mindsets',
  'New Mindsets and episodes added every month',
  'Download and watch / listen anywhere, anytime',
  'Members-only community & discussion',
  'Bonus content (i.e. Booster episodes)',
];
const yearlyMetadata = [
  'component.membership_upsell.metadata.1',
  'component.membership_upsell.metadata.2',
  'component.membership_upsell.metadata.3',
  'component.membership_upsell.metadata.4',
];
export class Plan {
  id: string;
  title: string;
  price: number;
  discountedPrice?: number;
  priceInUSD: number;
  priceDisplay: string;
  product: string;
  currency: string;
  metadata: string[];
  interval: string;

  constructor(data) {
    const { products = [] } = data || {};
    if (products[0]) {
      const {
        unitAmount,
        nickname,
        product,
        currency,
        id,
        metadata,
        recurring,
      } = products[0];
      this.product = product;
      this.title = '';
      this.price = unitAmount; // Price in cent
      this.priceInUSD = unitAmount / 100;
      this.priceDisplay = this.priceInUSD.toLocaleString();
      this.currency = currency;
      this.id = id;
      this.interval = recurring.interval;
      if (this.interval === 'year') {
        // Hard code for yearly plan
        this.title = 'general.annual_membership';
      } else {
        this.title = nickname;
      }
      this.discountedPrice = data.discountedPrice;
      if (!isEmpty(metadata)) {
        this.metadata = metadata;
      } else {
        this.metadata =
          this.interval === 'month'
            ? monthlyMetadata
            : yearlyMetadata.map((item) => i18n.t(item));
      }
    }
  }

  getDiscountedPrice(coupon) {
    let discountedPrice = 0;
    if (!coupon?.valid) discountedPrice = this.priceInUSD || 0;
    else {
      discountedPrice =
        (this.priceInUSD * (100 - (coupon?.percentOff ?? 0))) / 100;
    }
    this.discountedPrice = discountedPrice;
    return discountedPrice;
  }
}

export class Plan2 {
  id: string;
  merchantId: string;
  currency: string;
  title: string;
  price: number;
  priceInUSD: number;
  discountedPrice: number;
  createdAt: Moment;
  updatedAt: Moment;
  metadata: string[];
  interval: string;
  type: string;

  constructor(data) {
    if (data.type === REVENUE_CAT) {
      const { id, name, currency } = data;
      this.id = id;
      this.currency = currency;
      this.title = 'Annual Membership' || name;
      this.price = data.unitAmount / 100;
      this.priceInUSD = this.price;
    } else {
      const {
        id,
        merchantId,
        currencyIsoCode,
        name,
        price,
        createdAt,
        updatedAt,
      } = data || {};
      this.id = id;
      this.merchantId = merchantId;
      this.currency = currencyIsoCode;
      this.title = 'Annual Membership' || name;
      this.price = Number(price);
      this.priceInUSD = this.price;
      this.createdAt = moment(createdAt?.date).tz(createdAt?.timezone);
      this.updatedAt = moment(updatedAt?.date).tz(updatedAt?.timezone);
    }
    this.discountedPrice = this.discountedPrice || this.price;
    this.interval = 'year';
    this.metadata = yearlyMetadata.map((item) => i18n.t(item));
    this.type = data.type;
  }

  getDiscountedPrice(coupon) {
    if (!coupon) return this.priceInUSD;
    let discountedPrice = this.priceInUSD;
    if (coupon.amount) {
      discountedPrice = this.priceInUSD - coupon?.amount;
    } else if (coupon.percentOff) {
      discountedPrice =
        this.priceInUSD - (this.priceInUSD * coupon.percentOff) / 100;
    }
    this.discountedPrice = discountedPrice;
    return discountedPrice;
  }
}
